import { render, staticRenderFns } from "./DeveloperListing.vue?vue&type=template&id=4870ba52&"
import script from "./DeveloperListing.vue?vue&type=script&lang=js&"
export * from "./DeveloperListing.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperListing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports